import React, { Component } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChalkboardTeacher, faUsers, faMapMarkedAlt } from '@fortawesome/free-solid-svg-icons';
import { faSmileWink } from '@fortawesome/free-regular-svg-icons';

import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import Card from 'react-bootstrap/Card';
import Container from 'react-bootstrap/Container';

class CourseStadistics extends Component {
  render() {
    const sliderSettings = {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: false,
      autoplay: true,
      autoplaySpeed: 3500,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 4,
            infinite: true,
            autoplay: false,
            dots: true,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            initialSlide: 2,
            autoplay: true,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            autoplay: true,
          },
        },
      ],
    };

    return (
      <Container className='mt-2 pt-2 mb-5'>
        <Container className='text-center my-3'>
          <h1 style={{ color: '#3367FF' }}>Nuestras Capacitaciones en Números</h1>
          <div className='d-flex justify-content-center'>
            <div className='divider' />
          </div>
        </Container>
        <Container className='text-center my-5'>
          <p className='statistics-text-secondary my-5 my-md-4'>
            Nuestro historial, desempeño y experiencia es garantía de nuestro profesionalismo
          </p>
        </Container>
        <Slider {...sliderSettings} className='mx-md-4 my-5 py-0 py-md-5 px-md-4'>
          <Card className='stadistics-card'>
            <div className='d-flex justify-content-center'>
              <FontAwesomeIcon icon={faChalkboardTeacher} size='4x' color='#072379' className='mb-2' />
            </div>
            <Card.Body>
              <Card.Title className='stadistics-card-title'>153+</Card.Title>
              <div className='d-flex justify-content-center'>
                <div className='divider' />
              </div>
              <Card.Text className='statistics-card-text mt-3 mx-md-2 px-5 px-md-0'>
                Capacitaciones Impartidas
              </Card.Text>
            </Card.Body>
          </Card>
          <Card className='stadistics-card'>
            <div className='d-flex justify-content-center'>
              <FontAwesomeIcon icon={faUsers} size='4x' color='#072379' className='mb-2' />
            </div>
            <Card.Body>
              <Card.Title className='stadistics-card-title'>2478+</Card.Title>
              <div className='d-flex justify-content-center'>
                <div className='divider' />
              </div>
              <Card.Text className='statistics-card-text mt-3 mx-md-2 px-5 px-md-0'>Personas Capacitadas</Card.Text>
            </Card.Body>
          </Card>
          <Card className='stadistics-card'>
            <div className='d-flex justify-content-center'>
              <FontAwesomeIcon icon={faMapMarkedAlt} size='4x' color='#072379' className='mb-2' />
            </div>
            <Card.Body>
              <Card.Title className='stadistics-card-title'>14</Card.Title>
              <div className='d-flex justify-content-center'>
                <div className='divider' />
              </div>
              <Card.Text className='statistics-card-text mt-3 mx-md-2 px-5 px-md-0'>
                Ciudades de Latinoamérica
              </Card.Text>
            </Card.Body>
          </Card>
          <Card className='stadistics-card'>
            <div className='d-flex justify-content-center'>
              <FontAwesomeIcon icon={faSmileWink} size='4x' color='#072379' className='mb-2' />
            </div>
            <Card.Body>
              <Card.Title className='stadistics-card-title'>100%</Card.Title>
              <div className='d-flex justify-content-center'>
                <div className='divider' />
              </div>
              <Card.Text className='statistics-card-text mt-3 mx-md-2 px-5 px-md-0'>Clientes Satisfechos</Card.Text>
            </Card.Body>
          </Card>
        </Slider>
      </Container>
    );
  }
}

export default CourseStadistics;
